export default "__VITE_ASSET__BTBJZEnw__"